export const HubspotMapping = {
  static: false,
  defaultValue: null,
  driftAttribute: null,
  integrationAttribute: null,
  isOverwritable: null
}

export const HubspotUserMap = {
  driftUserId: null,
  integrationUserId: null
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/hubspot/models.js